<template>
  <div>
    <Menu>
      <li v-if="computer" class="menu-item">
        <a @click="showComputerInfo = true">
          <IconText icon="mdi-laptop">Details</IconText>
        </a>
      </li>

      <li class="menu-item">
        <a v-if="computer" @click="showComputerLog = true">
          <IconText icon="mdi-card-text-outline">Log</IconText>
        </a>
      </li>

      <li
        v-if="
          computer && domain && (!domain.permission || domain.permission >= 64)
        "
        class="menu-item"
      >
        <a @click="showPowershell = true">
          <IconText icon="mdi-powershell">Powershell</IconText>
        </a>
      </li>

      <li v-if="$route.params.domainUID" class="menu-item">
        <router-link
          :to="
            `/domains/${$route.params.domainUID}/computers/${$route.params.computerUID}/applications`
          "
        >
          <IconText icon="mdi-format-list-checks">Applications</IconText>
        </router-link>
      </li>
    </Menu>

    <Packages></Packages>
    <ComputerInfo
      v-if="showComputerInfo && computer"
      v-model="showComputerInfo"
      :computer="computer"
    ></ComputerInfo>

    <ComputerLog
      v-if="showComputerLog && computer"
      v-model="showComputerLog"
      :computer="computer"
    ></ComputerLog>

    <Powershell
      v-if="showPowershell && computer"
      v-model="showPowershell"
      :computer="computer"
    ></Powershell>
  </div>
</template>

<script>
export default {
  components: {
    Packages: () => import("@/components/main/packages/Computer.vue"),
    Menu: () => import("@/components/main/Menu.vue"),
    ComputerInfo: () => import("@/components/main/computer/Info.vue"),
    ComputerLog: () => import("@/components/main/computer/Log.vue"),
    Powershell: () => import("@/components/main/computer/Powershell.vue"),
    IconText: () => import("@/components/singles/IconText.vue"),
  },
  computed: {
    computer() {
      return this.$store.state.computer.computers.find(
        (x) => x.uid === this.$route.params.computerUID
      );
    },
  },
  data() {
    return {
      showComputerInfo: false,
      showComputerLog: false,
      showPowershell: false,
      domain: null,
      domainSub: null,
    };
  },
  beforeDestroy() {
    this.$store.commit("powershell/clear");
    if (this.domainSub) this.domainSub();
  },
  async created() {
    try {
      this.domain = this.$store.getters["domain/single"](
        this.$route.params.domainUID
      );

      if (!this.domain)
        this.domainSub = this.$store.subscribe((mutation, state) => {
          if (mutation.type == "domain/set")
            this.domain = this.$store.getters["domain/single"](
              this.$route.params.domainUID
            );
        });
    } catch (err) {
      console.log(err);
      this.$helpers.notify("Error", "Could not get data.", "danger", 5000);
    }
  },
};
</script>
